// 组件
import importImg from '@/components/importImg.vue'
// 接口
import * as hostsApi from '@/services/hosts.js'
// 其他
import dataDictionary from '@/utils/data-dictionary.js'
import constant from '@/utils/constant.js'
import verifyRules from '@/utils/verify-rules/index.js'
import loading from '@/utils/loading.json'

export default {
  components: {
    importImg
  },
  data () {
    return {
      constant,
      dataDictionary,
      verifyRules: verifyRules(this),
      urlParams: null,
      bankNameList: [],
      HostTypeList: [],
      mainForm: {
        fileData: {
          cover: null,
          icFront: null,
          icBack: null
        },
        data: {
          online: null,
          support_halal_products: null,
          support_refrigerated_products: null,
          support_frozen_products: null,
          zero_commission: null,
          host_type: null,
          host_code: null,
          host_password: null,
          name: null,
          phone_number: null,
          whatsapp_number: null,
          whatsapp_group_link: null,
          wechat_id: null,
          note: null,
          bank_name: null,
          bank_swift_code: null,
          account_name: null,
          account_number: null,
          paynow_number: null,
          remote_avatar_url: null,
          remote_ic_front_image_url: null,
          remote_ic_back_image_url: null
        }
      }
    }
  },
  created () {
    const _this = this
    _this.urlParams = _this.$route.params
  },
  mounted () {
    const _this = this
    const initRequest1 = hostsApi.getIdPreview(_this.urlParams.id).then(res => {
      const resData = res.data.host
      Object.assign(_this.mainForm.data, resData)
      _this.mainForm.data.remote_avatar_url = resData.avatar
      _this.mainForm.fileData.cover = [{ id: Date.now(), image_url: resData.avatar }]
      _this.mainForm.data.remote_ic_front_image_url = resData.ic_front_image
      _this.mainForm.fileData.icFront = [{ id: Date.now(), image_url: resData.ic_front_image }]
      _this.mainForm.data.remote_ic_back_image_url = resData.ic_back_image
      _this.mainForm.fileData.icBack = [{ id: Date.now(), image_url: resData.ic_back_image }]
      return res
    }).catch(err => err)
    const initRequest2 = hostsApi.getBankNameList().then(res => {
      _this.bankNameList = res.data.bank_name_list
      return res
    }).catch(err => err)
    const initRequest3 = hostsApi.getHostTypeList().then(res => {
      _this.HostTypeList = res.data.host_type_list
      return res
    }).catch(err => err)
    _this.setGlobalLoading(true)
    Promise.all([initRequest1, initRequest2, initRequest3]).then(() => {
      _this.setGlobalLoading(false)
    }).catch(() => {
      _this.setGlobalLoading(false)
    })
  },
  methods: {
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = this.$loading(loading) : this.$store.state.app.loading.close()
    },
    handleMainFormCoverChange (fileData) {
      const _this = this
      if (fileData && fileData.length > 0 && !fileData[0]._destroy) {
        _this.mainForm.data.remote_avatar_url = fileData[0].url
      } else {
        _this.mainForm.data.remote_avatar_url = null
      }
    },
    handleMainFormIcFrontChange (fileData) {
      const _this = this
      if (fileData && fileData.length > 0 && !fileData[0]._destroy) {
        _this.mainForm.data.remote_ic_front_image_url = fileData[0].url
      } else {
        _this.mainForm.data.remote_ic_front_image_url = null
      }
    },
    handleMainFormIcBackChange (fileData) {
      const _this = this
      if (fileData && fileData.length > 0 && !fileData[0]._destroy) {
        _this.mainForm.data.remote_ic_back_image_url = fileData[0].url
      } else {
        _this.mainForm.data.remote_ic_back_image_url = null
      }
    },
    handleMainFormCancelClick () {
      const _this = this
      _this.$router.go(-1)
    },
    handleMainFormSubmitClick () {
      const _this = this
      _this.$refs.mainForm.validate((valid) => {
        if (valid) {
          let requestParams = {}
          Object.assign(requestParams, _this.mainForm.data)
          // 后端代码专门将下面两个字段做了字符串转换，暂时不知道原因
          requestParams.support_refrigerated_products = requestParams.support_refrigerated_products.toString()
          requestParams.support_frozen_products = requestParams.support_frozen_products.toString()
          requestParams = {
            host: {
              ...requestParams
            }
          }
          _this.setGlobalLoading(true)
          hostsApi.putHostsId(_this.urlParams.id, requestParams).then(() => {
            _this.setGlobalLoading(false)
            _this.$message({
              type: 'success',
              message: _this.$t('message.operateSuccess')
            })
            setTimeout(() => {
              _this.$router.push({
                name: 'buddyManagerBuddyList'
              })
            }, constant.ROUTER_CHANGE_INTERVAL)
          }).catch(() => _this.setGlobalLoading(false))
        }
      })
    }
  }
}
